module.exports = __webpack_public_path__ + "img/login-lock.52b7f450.svg";